export const validateCriteria = (criteria: any): Record<string, any> => {
  const errors: Record<string, any> = {};

  if (!criteria?.LogicalOperatorType) {
    return errors;
  }

  let hasConditionErrors = false;
  const conditions = criteria.Conditions || [];

  conditions.forEach((condition: any, index: number) => {
    const conditionErrors: Record<string, any> = {};
    let hasSubCriteriaErrors = false;

    if (condition.SubCriteria?.LogicalOperatorType) {
      const subConditionsErrors: Record<string, any>[] = [];
      const subConditions = condition.SubCriteria.Conditions || [];

      subConditions.forEach((subCondition: any, subIndex: number) => {
        const subErrors: Record<string, any> = {};

        // Check if Field is null, undefined, or empty string
        if (
          subCondition.Field === null ||
          subCondition.Field === undefined ||
          subCondition.Field.trim() === ''
        ) {
          subErrors.Field = 'Required Field';
          hasSubCriteriaErrors = true;
          subConditionsErrors[subIndex] = subErrors;
        }
      });

      if (hasSubCriteriaErrors) {
        conditionErrors.SubCriteria = { Conditions: subConditionsErrors };
      }
    }

    if (Object.keys(conditionErrors).length > 0) {
      if (!errors.Conditions) {
        errors.Conditions = [];
      }
      errors.Conditions[index] = conditionErrors;
      hasConditionErrors = true;
    }
  });

  if (!hasConditionErrors) {
    delete errors.Conditions;
  }

  return errors;
};
